import { render } from "./SiteSettings.vue?vue&type=template&id=700cae11&scoped=true"
import script from "./SiteSettings.vue?vue&type=script&lang=js"
export * from "./SiteSettings.vue?vue&type=script&lang=js"

import "./SiteSettings.vue?vue&type=style&index=0&id=700cae11&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700cae11"]])

export default __exports__